import { Capacitor } from "@capacitor/core";
import {
  ActionPerformed,
  PushNotifications,
  Token,
} from "@capacitor/push-notifications";
import LimeAPI from "../classes/LimeAPI";
import store from "../store";

const abortController = new AbortController();
let pushInitialized = false;

export async function initPushNotifications(history: any): Promise<void> {
  // Endast iOS och Android – kör inte på webb
  const platform = Capacitor.getPlatform();
  if (platform !== "ios" && platform !== "android") {
    return;
  }

  // Initiera endast en gång
  if (pushInitialized) {
    return;
  }
  pushInitialized = true;

  try {
    const permResult = await PushNotifications.requestPermissions();
    if (permResult.receive !== "granted") {
      return;
    }

    await PushNotifications.register();
  } catch (e) {
    console.error("Push-initiering misslyckades:", e);
    return;
  }

  PushNotifications.addListener("registration", async (token: Token) => {
    const user = store.getState().user;
    if (!user.id || !user.sessionToken) {
      return;
    }

    try {
      const url = `${LimeAPI.apiUrl}/notifications/registerDevice`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Session-Token": user.sessionToken,
        },
        body: JSON.stringify({ fcmToken: token.value, platform }),
        signal: abortController.signal,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error("[Push] API fel:", res.status, res.statusText, data);
        return;
      }
      if (!data?.success) {
        console.error("[Push] API returnerade success=false:", data);
        return;
      }
    } catch (e) {
      console.error(
        "[Push] Kunde inte registrera enhet:",
        e instanceof Error ? e.message : String(e),
      );
    }
  });

  PushNotifications.addListener("registrationError", (error: any) => {
    console.error("Push-registrering misslyckades:", error);
  });

  PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (notification: ActionPerformed) => {
      const data = notification.notification.data;
      if (!data || !history) {
        return;
      }

      // Deep linking baserat på payload
      if (data.projectId && data.documentId) {
        history.push(
          `/projects/${data.projectId}/qualitydocument/${data.documentId}/`,
        );
      } else if (data.projectId) {
        history.push(`/projects/${data.projectId}`);
      }
    },
  );
}
